import React, { Component } from 'react';
import styled from 'styled-components';
import autoComplete  from '../assets/javascript/autocomplete.js';
import breakpoints from "../styles/breakpoints";
import Container from "./Core/Container";
import Section from "./Core/Section";

//css 
import '../assets/styles/calender.css'
import '../assets/styles/autocomplete.css'
import Litepicker from  '../assets/javascript/litepicker.js'
import Icon from "./Core/Icon";

const Styles = styled.div`
.hth {
	height: auto;
	background: var(--primary);
	padding: 1rem 0;
	width: 100%;
    box-sizing: border-box;
    text-align: left;
    
    &.hero {
        padding: 1rem;
        border-radius: .25rem;
        margin: auto;
        background: none;
    }

    .copy-container {
        margin: 0 0 1.5rem;
        color: var(--black);

        &.white {
            color: var(--white);
        }

        &--margin {
            margin: 0 0 3.125em;
        }
    }
    .heading {
        font-weight: 700;
        font-size: 1.5rem;
        margin: 0;
    }
    .tagline, .description {
        font-size: .875rem;
        margin: 1rem 0 0;
    }
	.fcon {
		display: flex;
		flex-direction: column;
	}
	.drop {
		position: relative;
	}
	.inner {
		height: 3.5rem;
		line-height: 3.5rem;
		background: #fff;
		border-radius: 0.313em;
		margin: 0.625rem 0 0 0;
		width: 100%;
		box-sizing: border-box;
		border: none;
		display: flex;
		flex-direction: column;
        position: relative;
        
        .date {
            cursor: pointer;
        }
      
		label {
			height: 1rem;
			font-size: 0.875rem;
			padding: .5rem 1rem 0;
			font-weight: 700;
			position: absolute;
			top: -1.313rem;
			pointer-events: none;
			color: #000;
		}
      
		input {
			line-height: 30px;
			border-radius: 15px;
			width: 100%;
			padding: 21px 16px 0;
			box-sizing: border-box;
			background: transparent;
			border: none;
			&:focus {
				outline: none;
			}
		}
		select {
			line-height: 30px;
			border-radius: 15px;
			width: 100%;
			padding: 21px 16px 0;
			box-sizing: border-box;
			background: transparent;
			border: none;
			cursor: pointer;
			-webkit-appearance: none;
			-moz-appearance: none;
			appearance: none;
            color: black;
			&:focus {
				outline: none;
			}
		}
	}
	.inner.region_box {
		margin: 0;
		input {
			padding: 1.313rem 2.813rem 0 1rem;
		}
	}
	.search_box {
		min-height: 3.5rem;
		.submit {
			height: 3.5rem;
			width: 100%;
			margin: 0;
			border: none;
			padding: 0;
			background: var(--secondary);
			color: #fff;
			font-weight: 700;
			cursor: pointer;
            border-radius: .313rem;
            
            &:hover,
            &:focus {
                background: var(--lightenButton);
                transition: .3s;
            }
		}
	}

	ul {
		list-style: none;
	}
	.close {
		height: 1.063rem;
		width: 0.813rem;
		position: absolute;
		right: 1.563rem;
		bottom: 2rem;
        cursor: pointer;
        z-index: 10;
	}
	.close.hide {
		display: none;
	}
	.foot {
		display: flex;
		margin: 10px 0 0 0;
		flex-direction: column;
		align-items: center;
		.snaptrip_box {
			display: flex;
			align-items: center;
			margin: 10px 0 0 0;
			svg {
				width: 120px;
			}
		}
		.hottub_box {
			display: flex;
			align-items: center;
		}
		p {
			color: #000;
			font-size: 12px;
			margin: 0 6px 0 0;
			display: flex;
            white-space: nowrap;

            &.white {
                color: #fff;
            }
            
		}
		label {
			color: #000;
			font-size: 12px;
			margin-left: 6px;
			cursor: pointer;
			user-select: none;
            padding-top: 3px;

            &.white {
                color: #fff;
            }
		}
		input {
			display: none;
			&:checked {
				+ {
					.checkbox {
						svg {
							display: block;
						}
						background: var(--secondary);
					}
				}
			}
		}
		.checkbox {
			height: 18px;
			width: 18px;
			background: #eeeeee;
			border-radius: 50%;
			cursor: pointer;
			display: flex;
			justify-content: center;
			align-items: center;
			svg {
				height: 12px;
				width: 12px;
				fill: var(--primary);
				display: none;
			}
		}
	}
	.hth-mobile {
		display: flex;
		.inner {
			width: calc(50% - 5px);
			&:first-of-type {
				margin-right: 10px;
			}
		}
	}
	#autofill {
		position: relative;
		z-index: 10;
	}
	.autocomplete-suggestion {
		position: relative;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		color: #333;
		font-size: 14px;
		background: #eee;
		padding: 16px 16px 2px 16px;
		cursor: pointer;
		line-height: 1.25;
		margin-top: -1px;
		&:last-of-type {
			padding: 16px;
			border-bottom-left-radius: 15px;
			border-bottom-right-radius: 15px;
		}
		&:hover {
			color: var(--primary);
			.sub-region {
				color: var(--primary);
			}
		}
	}
	.autocomplete-suggestion.selected {
		color: var(--primary);
		.sub-region {
			color: var(--primary);
		}
	}
}

@media only screen and (min-width: 600px) {
	.hth {
      padding: 1.25rem 0;

      &.hero {
        padding: 1.25rem;
      }
      
		.foot {
			justify-content: space-between;
			flex-direction: row;
			align-items: center;
          
			.snaptrip_box {
				margin: 0;
			}
		}
	}
}

@media only screen and (min-width: ${breakpoints.lg}) {
	.hth {
        width: 100%;

        &.hero {
            background: var(--primary);
        }
        
		.fcon {
			flex-direction: row;
        }
        
		.inner.region_box {
			input {
				padding: 21px 45px 0 16px;
			}
        }
        
		.inner {
			margin: 0 0 0 10px;
		}
		.hth-mobile {
			flex-direction: row;
			background: none;
			width: 100%;
			.inner {
				width: 50%;
				&:first-of-type {
					margin-right: 0;
				}
			}
		}
	}
}


`;

const ScrollButton = styled.button`
    position: fixed;
    bottom: 1rem;
    right: 1.25rem;
    box-shadow: 0 0 1.25rem rgb(0 0 0 / 30%);
    z-index: 100;
    height: 3rem;
    width: 3rem;
    border-radius: 50%;
    cursor: pointer;
    background-color: var(--secondary);
    border: none;

    svg {
        fill: white;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    span {
        display: none;
    }

    @media only screen and (min-width: ${breakpoints.lg}) {

        span {
            opacity: 0;
            display: inline;
            top: 1rem;
            transition: all ease .5s;
            position: absolute;
            color: #000;
            background: white;
            padding: 0.5rem 1rem;
            font-size: 0.65rem;
            width: 6.25rem;
            border-radius: 4px;
            right: 0;

            &::after {
                content: "";
                position: absolute;
                right: 18px;
                width: 0; 
                height: 0; 
                bottom: -7px;
                border-left: 7px solid transparent;
                border-right: 7px solid transparent;
                border-top: 7px solid #fff;
            }
        }

        &:hover,
        &:focus {

            span {
                top: -2rem;
                opacity: 1;
            }

        }
    }
`;

class WhitelabelSearchForm extends Component {
    constructor (params) {
        super(params)
        this.checkInRef = React.createRef()
        this.checkOutRef = React.createRef()
        this.regionRef = React.createRef()
        this.fixedRef = React.createRef()
    }

    state = {
        nights: "",
        checkout: "",
        datepicker: "",
        guests: "",
        region: "",
        date: "",
        heading: "",
        description: "",
        hotTub: this.props.hotTubFilter ? true : false,
        filters: {
            //property types
            apartment: this.props.apartmentFilter ? true : false,
            holidayHome: this.props.holidayHomesFilter ? true : false,
            lodge: this.props.lodgeFilter ? true : false,
            hotel: this.props.hotelFilter ? true : false,

            //filters
            pool: this.props.poolFilter ? true : false,
            coastal: this.props.coastalFilter ? true : false,
            luxury: this.props.luxuryFilter ? true : false,
            wifi: this.props.wifiFilter ? true : false,
            pets: this.props.petsFilter ? true : false,
        }

    };

    changeRegion = (event) => {
        this.setState({region: event.target.value});
    }

    changeNights = (event) => {
        this.setState({nights: event.target.value});
    }

    changeDate = (event) => {
        this.setState({date: event.target.value});
    }

    changeGuests = (event) => {
        this.setState({guests: event.target.value});
    }

    emptyRegion = () => {
        this.setState({region: ""});
        this.regionRef.current.focus();
    }

    checkHottub = (el) => {
        var app = this;
        app.setState({hotTub: !app.state.hotTub});
    }

    ajaxRequest = (options, suCallback, erCallback) => {
        var xhr = new XMLHttpRequest(),
            status = typeof options.status !== "undefined" ? options.status : 200;
        xhr.open(options.type, options.url, true);
        xhr.setRequestHeader('Content-Type', options.header);
        if (typeof options.accept !== "undefined") {
            xhr.setRequestHeader('Accept', options.accept);
        }
        if (typeof options.auth !== "undefined") {
            xhr.setRequestHeader('Authorization', options.auth);
        }
        if (typeof options.custom !== "undefined") {
            xhr.setRequestHeader(options.custom[0], options.custom[1]);
        }
        xhr.setRequestHeader('X-CSRF-Token', options.csrf);
        xhr.setRequestHeader('X-Requested-With', "XMLHttpRequest");
        xhr.onreadystatechange = function () {
            var response;
            if (xhr.readyState === 4 && xhr.status === status) {
                response = options.dataType === "json" ? JSON.parse(xhr.responseText) : xhr.responseText;
                if (typeof suCallback !== 'undefined') {
                    suCallback(response);
                }
            } else if (xhr.readyState === 4 && (xhr.status === 500 || xhr.status === 404 || xhr.status === 400)) {
                if (typeof erCallback !== 'undefined') {
                    erCallback(xhr);
                }
            }
        };
        xhr.send(options.data);
    }

    openDatepicker = () => {
        var app = this;
        app.state.datepicker.show();
    }

    conductSearch = (event) => {
        var app = this;
        event.preventDefault();
        app.dataLayerPush("outbound-search", "booking.com search");
        app.createUrl();
    }

    makeToAndFromDate = (date, nights) => {
        let nextDate = parseInt(nights * 86400000);
        return this.getUserDate(new Date(date).getTime() + nextDate);
    }

    getUserDate = (date, day) => {
        var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            that = new Date(date),
            sp = " ",
            hasDay;
        hasDay = typeof day !== "undefined" ? days[that.getDay()] + sp : "";
        return hasDay + that.getDate() + sp + months[that.getMonth()] + sp + that.getFullYear();
    }

    createUrl = () => {
        let entryPage,
        exitPage;

        if (typeof window !== "undefined") {
            entryPage = "https://www.holidayparks.com" + window.sessionStorage.getItem("landingUrl");
            exitPage = window.location.href;
        }

        var app = this;
        var filters = app.state.filters;
        var aid = "1910501";
        var params = window.location.search;
        var utmSource = params.includes("utm_source") ? params.split("utm_source=")[1].split("&")[0] : "hottub-hideaways";
        var utmMedium = params.includes("utm_medium") ? params.split("utm_medium=")[1].split("&")[0] : "affiliate-site";
        var utmCampaign = params.includes("utm_campaign") ? params.split("utm_campaign=")[1].split("&")[0] : `&utm_campaign=searchform-Unlabelled-landing-${entryPage}-click-${exitPage}`;
        var utmTerm = params.includes("utm_term") ? params.split("utm_term=")[1].split("&")[0] : "";
        var gclid = params.includes("gclid") ? params.split("gclid=")[1].split("&")[0] : "";
        var msclkid = params.includes("msclkid") ? params.split("msclkid=")[1].split("&")[0] : "";

        var utmParams = `&label=HTH${utmSource.length > 0 ? 'X' + utmSource : ''}${utmMedium.length > 0 ? 'X' + utmMedium : ''}${utmCampaign.length > 0 ? 'X' + utmCampaign : ''}${utmTerm.length > 0 ? 'X' + utmTerm : ''}${gclid.length > 0 ? 'X' + gclid : ''}${msclkid.length > 0 ? 'X' + msclkid : ''}`;

        let date = new Date(app.state.date),
            endDate = new Date(app.makeToAndFromDate(app.state.date, app.state.nights)),
            format = (n) => { return (parseInt(n) + 1).toLocaleString('en-GB', {minimumIntegerDigits: 2, useGrouping: false}) };

        let sleeps = app.state.guests,
            startDay = date.getDate(),
            startYearMonth = date.getFullYear() + "-" + format(date.getMonth()),
            endYearMonth = endDate.getFullYear() + "-" + format(endDate.getMonth()),
            endDay = endDate.getDate(),
            url,
            filtersUrl = "";

        //filters 
        filters.coastal ? filtersUrl = filtersUrl + 'ht_beach=1;' : null;
        filters.luxury ? filtersUrl = filtersUrl + 'class=4;class=5;' : null;
        filters.apartment ? filtersUrl = filtersUrl + 'percent_htype_apt=1;ht_id=201;' : null;
        filters.holidayHome ? filtersUrl = filtersUrl + 'ht_id=220;' : null;
        filters.lodge ? filtersUrl = filtersUrl + 'ht_id=221;' : null;
        filters.hotel ? filtersUrl = filtersUrl + 'percent_htype_hotel=1;ht_id=204;' : null;

        filters.pool ? filtersUrl = filtersUrl + 'hotelfacility=301;' : null;
        filters.wifi ? filtersUrl = filtersUrl + 'hotelfacility=107;' : null;
        filters.pets ? filtersUrl = filtersUrl + 'hotelfacility=4;' : null;
        app.state.hotTub ? filtersUrl = filtersUrl + 'popular_activities=63' : null;
        filtersUrl.length > 0 ? filtersUrl = '&nflt=' + filtersUrl.replace(/=/g, '%3D').replace(/;/g, '%3B') : null;

        url = app.state.region ? `https://book.laterooms.com/searchresults.en.html?ss=${app.state.region.includes(',') ? app.state.region.split(',')[0] : app.state.region}${app.state.date ? '&checkin_monthday=' + startDay : ""}${app.state.date? "&checkin_year_month=" + startYearMonth : ""}${ app.state.date ? "&checkout_monthday=" + endDay : ""}${ app.state.date ? "&checkout_year_month=" + endYearMonth: ""}&do_availability_check=1&order=popularity${sleeps ? "&group_adults=" + sleeps : ""}${filtersUrl}&aid=${aid}` : `https://book.laterooms.com/?aid=${aid}`;
        this.openInNewTab(url + utmParams);
    }

    openInNewTab = (url) => {
        var win = window.open('/redirect?url=' + url, '_blank');
        win.focus();
    }

    formScroll = () => {
        let el;
        this.fixedRef ? el = this.fixedRef.current : '';

        //get screen width 
        let w = window.innerWidth;
        if (w > 1280 && el) {
            var diff = w - 1280;
            el.style.right = ((diff / 2) + 20) + 'px';
        } else if (el) {
            el.style.right = '1.25rem'
        }
        
    }

    dataLayerPush = (outboundEvent, outbountURL) => {
        if (typeof window !== 'undefined'){
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({'event': outboundEvent,  'outbound-destination': outbountURL});
        }
    }

    scrollToform = () => {
        let el = this.regionRef.current;

        setTimeout(() => {
            if (typeof window !== `undefined`) {
                window.scrollTo({
                    top: el.getBoundingClientRect().top + window.pageYOffset,
                    behavior: 'smooth',
                });
            }
            el.focus();
          }, 50);
    }

    componentDidMount () {
        let app = this;

        app.setState({heading: app.props.heading});
        app.setState({description: app.props.description});

        // check for override then apply it to the region/dates/nights/guests respectively
        if (app.props.override) {
            app.setState({region: app.props.override});
        }

        if (app.props.region) {
            app.setState({region: app.props.region});
        }

        if (app.props.overrideDate) {
            var d = new Date(app.props.overrideDate);
            app.setState({date: d.toString().split('01:00:00')[0]});
        }

        if (app.props.overrideNights) {
            app.setState({nights: app.props.overrideNights});
        }

        if (app.props.overrideGuests) {
            app.setState({guests: app.props.overrideGuests});
        }

        //check for location in order to build correctly on Server Side
        // ppc page only
        if (typeof location !== `undefined` && this.props.ppc) {
            var url = location.href;
            var region = url.includes("region=") ? location.href.split("region=")[1]: "";
            region = region.includes("&") ? region.split('&')[0] : region;
            region ? app.setState({region: decodeURI(region)}): null;
        }

        if (typeof window !== `undefined`) {

            window.addEventListener('scroll', this.formScroll);
            window.addEventListener('resize', this.formScroll);

            app.setState({datepicker: new Litepicker({
            element: app.checkInRef.current,
            elementEnd: app.checkOutRef.current,
            singleMode: false,
            autoRefresh: true,
            allowRepick: true,
            minDate: new Date() -1,
            numberOfColumns: 2,
            numberOfMonths: 2,
            minDays: 2,
            maxDays: 29,
            format: "D MMM YYYY", 
            tooltipText: {
              one: 'night',
              other: 'nights'
            },
            tooltipNumber: (totalDays) => {
              return totalDays - 1;
            },
            resetButton: () => {
                let btn = document.createElement('button');
                btn.innerText = 'Clear';
                btn.disabled = true;
                btn.setAttribute("id", 'clear-button');
                btn.setAttribute("class", "reset-button");

                btn.addEventListener('click', (evt) => {
                    evt.preventDefault();
                });

                return btn;
            },
            setup: (picker) => {

                let nav = document.getElementById('nav');

                picker.on('preselect', (date1, date2) => {
                    if (date1 && !date2) {
                        app.setState({date: date1.dateInstance.toString().split('00:00:00')[0]});
                        app.setState({checkout: ""});
                        document.getElementById('clear-button').disabled = false;
                    }
                });

                picker.on('selected', (date1, date2) => {
                        var timeDiff = Math.abs(date2.dateInstance.getTime() - date1.dateInstance.getTime());
                        var numberOfNights = Math.ceil(timeDiff / (1000 * 3600 * 24));

                        setTimeout(() => {
                            app.setState({date: date1.dateInstance.toString().split('00:00:00')[0]});
                            app.setState({nights: numberOfNights});
                            app.setState({checkout: date2.dateInstance.toString().split('00:00:00')[0]});
                        });
                        
                });

                picker.on('show', (el) => {
                    //add close button for mobile
                    var cal = picker.ui;

                    cal.insertAdjacentHTML('afterend', '<button class="litepicker-close">Close</button>');

                    if (innerWidth < 1025) {
                        document.body.style.overflow = "hidden";
                        document.body.style.position = "fixed";
                    }

                    //if you've clicked on the check out field, then the check in should remain the same and you should begin by editing the check out
                    if (el.id !== 'checkout' && app.state.date) {
                        picker.clearSelection(); 
                    }

                    //to do with toggling nav on mobiles
                    nav.dataset.show = true;
                    
                });

                picker.on('hide', () => {
                    document.querySelector('button.litepicker-close').remove();
                    document.body.style.overflow = "auto";
                    document.body.style.position = "relative";
                    nav.dataset.show = false;
                });
            
            }
          })
        });
        }

        new autoComplete({
            selector: app.regionRef.current,
            minChars: 1,
            cache: false,
            source: function (term, suggest) {
                app.ajaxRequest({
                    url: "https://www.laterooms.com/2.5/json/autocomplete?language=en&text=" + term,
                    type: "GET",
                    dataType: "json"
                }, function (response) {
                    suggest(response.result);
                });
            },
            renderItem: function(item, search) {
                item = item.label;
                search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
                if(item.includes(",")){
                    return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>").replace(",", "+").split("+")[0] + '<br /><span class="sub-region">' + item.replace(re, "<b>$1</b>").replace(",", "+").split("+")[1]  + '</span></div>';
                } else {
                    return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>") + '</div>';
                }
            },
            onSelect: function (e, term, item) {
                e.preventDefault();
                app.setState({region: term});
            }
        });
    }



    componentWillUnmount() {
        if (typeof window !== `undefined`) {
            window.removeEventListener('scroll', this.formScroll);
            window.removeEventListener('resize', this.formScroll);
        }
    }

    render() {
        let showCopy = (this.props.heading || this.props.tagline || this.props.description);

        let guestsArr = [];
        for (let i = 1; i <= 10; i++) {
            guestsArr.push(i);
        }

        return (
            <Section id={this.props.id ? this.props.id : null}>
            <Styles>
                <div className={`hth ${this.props.hero ? "hero" : ""}`} id="search-form">
                    <Container fullWidthMobile={this.props.fullWidthMobile}>
                    { showCopy ? <div className={`copy-container ${this.props.color ? "white" : ""}`}>
                            {this.props.heading && !this.props.property ? <h1 className="heading">{this.state.heading ? this.state.heading : this.props.heading}</h1> : null}
                            {this.props.heading && this.props.property ? <h2 className="heading">{this.state.heading ? this.state.heading : this.props.heading}</h2> : null}
                            {this.props.tagline && <p className="tagline">{this.props.tagline}</p>}
                            {this.props.description && <p className="description">{this.state.description ? this.state.description : this.props.description }</p>}
                    </div> : null}
                    <form onSubmit={this.conductSearch}>
                        <div className="fcon">
                            <div className="inner region_box">
                                <label htmlFor="region">Destination</label>
                                <input id="region" ref={this.regionRef} value={this.state.region}  className="region" name="region" type="text" placeholder="Where are you travelling?" autoComplete="off" onChange={this.changeRegion}/>
                                { this.state.region && <div className="ico close" onClick={this.emptyRegion}>✕</div> }
                                <ul className="drop">
                                    <li id="autofill"/>
                                </ul>
                            </div>
                            <div className="hth-mobile">
                                <div className={`inner date_box`}>
                                    <label htmlFor="date">Check in*</label>
                                    <input id="date" ref={this.checkInRef} name="d8" placeholder="Add dates" readOnly value={this.state.date} type="text" className="date" autoComplete="off" />
                                </div>
                                <div className={`inner date check-out`} >
                                    <label htmlFor="checkout">Check out*</label>
                                    <input className="date" ref={this.checkOutRef} name="checkout" readOnly value={this.state.checkout} type="text" autoComplete="off" id="checkout" placeholder="Add dates" />
                                </div>
                            </div>
                            <div className="hth-mobile">
                                <div className="inner guest_box">
                                    <label htmlFor="guests">Guests</label>
                                    <select name="guests" id="guests" className="date long" onChange={this.changeGuests} value={this.state.guests}>
                                        <option className="disabled" value="" disabled >Add guests</option>
                                        {guestsArr.map((index) => {
                                            return <option value={index} key={index}>{index}+ Guest{ index > 1 ? 's' : ''}</option>
                                        })}
                                    </select>
                                </div>
                                <div className="inner search_box">
                                    <button className="submit">Search</button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="foot">
                        <div className="hottub_box">
                            <input id="hottub" type="checkbox" name="hottub" checked={this.state.hotTub} readOnly/>
                            <span className="checkbox" onClick={this.checkHottub}> 
                                <svg viewBox="0 0 512 512">
                                    <path d="m187 434l-173-166 48-47 125 120 263-252 48 46z"></path>
                                </svg>
                            </span>
                            <label htmlFor="hottub" onClick={this.checkHottub} className={` ${this.props.color ? "white" : ""}`}> Show me only properties with hot-tubs</label>
                        </div>
                        <div className="snaptrip_box">
                            <div className="thrv_wrapper thrv_text_element">
                                <p className={` ${this.props.color ? "white" : ""}`}>Powered by</p>
                            </div>
                            <svg viewBox="0 0 265 32" fill={` ${this.props.color ? "#fff" : "#000"}`}>
                                <path d="M85.6 13.1c-0.6 0.7-1.5 1.1-2.7 1.1h-2l-0.1-7.6 2.1-0.2c1.3 0 2.2 0.3 2.8 0.9 0.6 0.6 0.9 1.6 0.9 3 0 1.2-0.3 2.1-0.9 2.9zM96.3 25.8h-0.6c-0.6 0-1.1-0.1-1.4-0.4-0.3-0.3-0.4-0.7-0.4-1.4l0-1.1c0-2-0.3-3.6-1-4.7-0.7-1.1-2-1.8-3.8-2v-0.1c1.8-0.3 3-1 3.8-2.3 0.8-1.2 1.2-2.9 1.2-4.9 0-1.1-0.1-2.2-0.4-3.2-0.3-1-0.8-1.8-1.4-2.5-0.7-0.7-1.5-1.3-2.5-1.7-1-0.4-2.3-0.6-3.8-0.6h-9.3v-0.2l0 0.2h0l-4.4-0.1 0.6 10 0.3 9.9-0.1 10.3 8.6-0.3-0.9-12h2.9c0.5 0 0.9 0.1 1.2 0.2s0.6 0.4 0.8 0.7c0.2 0.3 0.4 0.7 0.4 1.3 0.1 0.6 0.1 1.3 0.1 2.1v2c0 0 0.1 2.3 0.4 3 0.2 0.8 0.6 1.3 1.1 1.7 0.5 0.4 1.2 0.6 2 0.7 0.8 0.1 1.8 0.2 2.9 0.2 0.6 0 1.4 0 2.1 0 0.9 0 1.6-0.1 2.3-0.2l-0.6-5zM224.7 26.4l-0.8 0c-0.9 0-1.7-0.7-1.7-1.6l-0.6-10.7c0-0.9 0.7-1.7 1.6-1.8l0.8 0c0.9 0 1.7 0.7 1.8 1.6l0.6 10.7c0 0.9-0.7 1.7-1.6 1.8zM233.3 14.8c-0.2-1.4-0.6-2.7-1.2-3.8-0.6-1.1-1.6-1.9-2.9-2.6-1.3-0.6-3-0.9-5.2-0.9-2.1 0-3.8 0.3-5.1 1-1.3 0.7-2.2 1.6-2.9 2.7-0.7 1.1-1.1 2.4-1.3 3.8-0.2 1.4-0.3 2.9-0.3 4.4 0 1.6 0.1 3.2 0.3 4.6 0.2 1.4 0.6 2.7 1.2 3.8 0.6 1.1 1.6 1.9 2.9 2.5 1.3 0.6 3 0.9 5.2 0.9 2.1 0 3.8-0.3 5.1-1 1.3-0.7 2.2-1.5 2.9-2.6 0.7-1.1 1.1-2.4 1.3-3.8 0.2-1.4 0.3-2.9 0.3-4.4 0-1.6-0.1-3.2-0.3-4.6zM202 13.8c0.2-0.5 0.4-0.9 0.7-1.1 0.3-0.2 0.9-0.3 1.3-0.3 0.8 0 1.4 0.3 1.7 1 0.2 0.4 0.3 0.8 0.4 1.4 0.1 0.6 0.1 1.3 0.1 2.2h6.7c0-1.4-0.1-2.7-0.4-3.9-0.3-1.2-0.7-2.1-1.4-3-0.7-0.8-1.5-1.5-2.6-1.9-1.1-0.5-2.5-0.7-4.1-0.7-1.4 0-2.7 0.1-4 0.4-1.2 0.3-2.3 0.9-3.2 1.7-0.9 0.9-1.6 2.1-2.1 3.7-0.5 1.6-0.8 3.8-0.8 6.4 0 2.5 0.2 4.4 0.7 5.9 0.5 1.5 1.1 2.6 2 3.5 0.8 0.8 1.9 1.4 3 1.6 1.2 0.2 2.5 0.4 4 0.4 3.2 0 5.5-0.7 6.9-2.2 0.7-0.8 1.2-1.8 1.5-3.1 0.3-1.3 0.5-1.9 0.5-3.7l-6.7-0.8v1.5c0 1.4-0.2 2.4-0.6 2.9-0.4 0.5-0.9 0.8-1.6 0.8-0.4 0-1-0.1-1.3-0.3-0.3-0.2-0.5-0.6-0.7-1.1-0.2-0.5-0.1-1.3-0.2-2.2-0.1-0.9-0.1-2.1-0.1-3.4 0-1.4 0-2.5 0.1-3.5 0.1-0.9 0-1.6 0.2-2.2zM186.1 22.4v8.2h7.8l-0.9-7.9-6.9-0.4zM264.3 10.7c-0.3-0.8-0.7-1.4-1.2-1.9-0.5-0.5-1.1-0.8-1.8-1-0.7-0.2-1.5-0.3-2.3-0.3-1.2 0-2.2 0.3-3.3 0.8-1 0.5-1.8 1.4-2.4 2.7-0.5-1.2-1.1-2-1.9-2.6-0.8-0.6-2-0.8-3.5-0.8-2.6 0-4.4 1.1-5.4 3.3h-0.7l0.6-2.8h-7.2v22.1l8.3 0.8-0.8-15.2c0-0.9 0.1-1.6 0.4-2 0.3-0.4 0.8-0.6 1.4-0.6 0.7 0 1.1 0.2 1.4 0.6s0.4 1.1 0.4 2v14.6l7.5 0v-14.6c0-0.3 0-0.5 0-0.7v-0.5c0-0.8 0.7-1.5 1.5-1.5h0.7c0.8 0 1.5 0.7 1.5 1.5l0 0.7c0 0.2 0 0.3 0 0.5l-0.2 4-0.5 10.6 8.2 0.6v-17.3c0-1.2-0.2-2.2-0.5-3zM164.2 10.8c-0.3-0.8-0.7-1.4-1.2-1.9-0.5-0.5-1.1-0.8-1.8-1-0.7-0.2-1.5-0.3-2.3-0.3-1.2 0-2.2 0.3-3.2 0.8-1 0.5-1.8 1.4-2.4 2.7-0.5-1.2-1.1-2-1.9-2.6-0.8-0.6-2-0.9-3.5-0.9-2.6 0-4.4 1.1-5.4 3.3h-0.4l0.3-2.8h-7.2v22.6h8.3l-0.8-14.9c0-1 0.1-1.6 0.4-2 0.3-0.4 0.8-0.6 1.4-0.6 0.6 0 1.1 0.2 1.4 0.6 0.3 0.4 0.4 1.1 0.4 2v14.9l7.5-0.8v-14.1c0-0.3 0-0.5 0-0.8v-0.5c0-0.8 0.7-1.5 1.5-1.5h0.7c0.8 0 1.5 0.7 1.5 1.5l0 0.7c0 0.2 0 0.3 0 0.5l-0.2 4-0.5 10.9 8.2 0v-17c0-1.2-0.2-2.2-0.5-3zM59.5 13.8c0.1-1.1 1-1.9 2.1-1.9l0.9 0c1.1 0.1 1.9 1 1.8 2.1l-0.1 2.7h-4.8l0.2-2.9zM59.1 22.6v-1.9h12v-2.3c0-2.1-0.2-3.8-0.6-5.2-0.4-1.4-0.9-2.5-1.7-3.3-0.8-0.8-1.7-1.5-2.8-1.8-1.1-0.4-2.4-0.5-3.9-0.5-1.7 0-3.1 0.2-4.3 0.6-1.2 0.4-2.2 1.1-3 2.1-0.8 0.9-1.3 2.2-1.7 3.7-0.4 1.5-0.5 3.3-0.5 5.5 0 2.1 0.2 4 0.5 5.5 0.3 1.5 0.8 2.7 1.6 3.7 0.8 0.9 1.7 1.6 3 2 1.2 0.4 2.7 0.6 4.5 0.6 3.1 0 5.3-0.7 6.7-2.1 1.4-1.4 2.1-2.7 2.1-5.4l-6.7-0.9c0 1.5-0.2 2.6-0.6 3.1 0 0 0 0 0 0.1-0.1 0.2-0.2 0.3-0.4 0.4 0 0 0 0-0.1 0.1-0.3 0.2-0.7 0.4-1.2 0.4l-0.9 0c-1.1 0-1.9-0.7-1.9-1.7v-2.4h0zM50.9 25.7c-0.6 0-1.1-0.1-1.4-0.4-0.3-0.3-0.4-0.7-0.4-1.4v-10.8h2.7l1.4-5.6-4.8 0.7 0.8-7.6-7.5 0.8v7.5l-2.5 0.3 0 1.1h0v2.8h2.5v12.1c0 1.3 0.1 2.3 0.3 3 0.2 0.8 0.6 1.4 1.1 1.7 0.5 0.4 1.2 0.6 2 0.7 0.8 0.1 1.8 0.2 2.9 0.2 0.6 0 1.4 0.1 2.1 0 0.7-0.1 2.1-0.1 2.9-0.2l-0.8-5h-1.2zM31.2 22.2c0 1.4-0.2 2.4-0.6 3.1-0.4 0.7-1.1 1-2 1-0.6 0-1.1-0.2-1.5-0.7-0.4-0.5-0.6-1.1-0.6-2 0-0.8 0.1-1.5 0.4-2 0.2-0.5 0.7-0.9 1.3-1.2 0.6-0.3 1.2-0.4 1.7-0.5 0.5-0.1 1.2-0.1 1.2 0.4l0 0.3v1.7zM39.8 25.7c-0.6 0-1.1-0.1-1.4-0.4-0.3-0.3-0.4-0.7-0.4-1.4l0-9.2 0 0c0-1.5-0.2-2.7-0.6-3.6-0.4-0.9-1-1.7-1.8-2.2-0.8-0.6-1.7-0.9-2.8-1.1-1.1-0.2-2.3-0.3-3.6-0.3-0.9 0-1.8 0.1-2.8 0.3-1 0.2-1.9 0.5-2.8 1.1-0.9 0.6-1.6 1.3-2.2 2.3-0.6 1-0.9 1.5-0.9 3.1l6.5 0.9c0-1.2 0.2-2 0.6-2.5 0.3-0.4 0.9-0.6 1.6-0.6 1.3 0 1.9 0.7 1.9 2.1 0 0.7-0.2 1.2-0.5 1.6-0.3 0.4-0.9 0.7-1.7 0.9l-3 0.7c-1.2 0.3-2.2 0.6-3 1-0.8 0.4-1.5 0.9-1.9 1.5-0.5 0.6-0.8 1.2-1 2-0.2 0.8-0.3 1.7-0.3 2.8 0 1 0.1 1.9 0.3 2.7 0.2 0.8 0.6 1.5 1.1 2.1 0.5 0.6 1.1 1 1.9 1.3 0.8 0.3 1.8 0.4 2.9 0.4 1.2 0 2.2-0.2 3.1-0.8 0.9-0.5 1.6-1.3 2-2.3h0.4l0 0.1c0.2 0.8 0.6 1.3 1.1 1.7 0.5 0.4 1.2 0.6 2 0.7 0.8 0.1 1.4 0.2 2.5 0.2 0.6 0 1.4 0.1 2 0 0.7-0.1 0.9 0 1.6-0.1l-0.3-5.1h-0.4zM8.2 24.4l0.9-24.4-8.6 0.8v29.9h18.3l-0.8-7.1-9.7 0.7zM125.6 25.1c-0.1 0.9-0.8 1.6-1.7 1.6l-0.8 0c-0.9 0-1.6-0.8-1.6-1.8l0.6-10.7c0.1-0.9 0.8-1.6 1.8-1.6l0.8 0c0.9 0 1.6 0.8 1.6 1.8l-0.6 10.7zM107 26.7l-0.8 0c-0.9 0.1-1.7-0.7-1.7-1.6l-0.6-10.7c0-0.9 0.7-1.7 1.6-1.8l0.8 0c0.9 0 1.7 0.7 1.8 1.6l0.6 10.7c0.1 0.9-0.7 1.7-1.6 1.8v0zM133.1 15.1c-0.2-1.4-0.6-2.7-1.2-3.8-0.6-1.1-1.6-1.9-2.9-2.6-1.3-0.6-3-0.9-5.2-0.9-2.1 0-3.8 0.4-5.1 1-1.3 0.7-2.2 1.6-2.9 2.7-0.3 0.5-0.5 0.9-0.7 1.4-0.2-0.6-0.4-1.1-0.7-1.6-0.6-1.1-1.6-1.9-2.9-2.6-1.3-0.6-3-0.9-5.2-0.9-2.1 0-3.8 0.4-5.1 1-1.3 0.7-2.2 1.6-2.9 2.7-0.7 1.1-1.1 2.4-1.3 3.8-0.2 1.4-0.3 2.9-0.3 4.3 0 1.6 0.1 3.2 0.3 4.6 0.2 1.4 0.6 2.7 1.2 3.8 0.6 1.1 1.6 1.9 2.9 2.5 1.3 0.6 3 0.9 5.2 0.9 2.1 0 3.8-0.3 5.1-1 1.3-0.6 2.2-1.5 2.9-2.6 0.3-0.4 0.5-0.9 0.7-1.4 0.2 0.6 0.4 1.1 0.7 1.6 0.6 1.1 1.6 1.9 2.9 2.5 1.3 0.6 3 0.9 5.2 0.9 2.1 0 3.8-0.3 5.1-1 1.3-0.6 2.2-1.5 2.9-2.6 0.7-1.1 1.1-2.4 1.3-3.8 0.2-1.4 0.3-2.9 0.3-4.3 0-1.6-0.1-3.2-0.3-4.6v0zM183.2 20.5c-0.6-0.9-1.2-1.6-2-2.1-0.8-0.5-1.7-0.9-2.6-1.2-0.9-0.3-1.8-0.5-2.6-0.8-0.8-0.2-1.5-0.5-2-0.9-0.5-0.3-0.8-0.8-0.8-1.4 0-0.6 0.2-1 0.6-1.3 0.4-0.3 0.8-0.5 1.4-0.5 0.7 0 1.2 0.2 1.5 0.5 0.4 0.3 0.5 1 0.5 2l6.4-0.3c0-4.7-2.8-6.8-8.5-6.8-1.5 0-2.9 0.2-4 0.5-1.1 0.4-2.1 0.9-2.8 1.5-0.7 0.6-1.3 1.4-1.6 2.2-0.4 0.9-0.6 1.8-0.6 2.8 0 1.4 0.3 2.6 0.8 3.5 0.5 0.9 1.2 1.6 2 2.1 0.8 0.5 1.7 0.9 2.6 1.3 0.9 0.3 1.8 0.6 2.6 0.9 0.8 0.3 1.5 0.6 2 1 0.5 0.4 0.8 0.9 0.8 1.5 0 0.6-0.2 1.1-0.6 1.4-0.4 0.3-0.9 0.5-1.5 0.5-0.7 0-1.2-0.3-1.6-0.8-0.2-0.2-0.3-0.6-0.4-1-0.1-0.4-0.1-0.8-0.1-1.2h0v-0.2l-6.6-0.8 0 1.3h0c0 2.5 0.7 4 2.1 5.3 1.4 1.3 3.6 1.9 6.8 1.9 1.4 0 2.7-0.2 3.8-0.5 1.1-0.3 2.1-0.8 2.8-1.5 0.8-0.7 1.4-1.5 1.8-2.4 0.4-0.9 0.6-1.9 0.6-3.1 0-1.5-0.3-2.6-0.8-3.5z"/>
                            </svg>
                        </div>
                    </div>
                    { this.props.scrollToForm && <ScrollButton ref={this.fixedRef} onClick={this.scrollToform}>
                        <svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 30 30" width="30px" height="30px"><path d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z"/></svg>
                        <span>Take me to Search</span>
                    </ScrollButton>}
                    </Container>
                </div>
            </Styles>
            </Section>
        )
    }
}

export default WhitelabelSearchForm;